"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSnackbar = void 0;
const react_1 = require("react");
function useSnackbar() {
    const ref = react_1.useRef(null);
    const context = react_1.useMemo(() => ({
        showSnackbar: (msg, variant, autohide) => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.showSnackbar(msg, variant, autohide); },
    }), []);
    return { context, ref };
}
exports.useSnackbar = useSnackbar;
//# sourceMappingURL=snackbar-hook.js.map